import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../assets/styles/Home.css';
import smartCMA from '../assets/images/logos/smart_cma_small.png';
import smartReport from '../assets/images/logos/smart_reports_small.png';
import smartSearch from '../assets/images/logos/smart_search_small.png';
import { useAuth } from './utils/utils';

const Home = () => {
  const history = useHistory();
  const { validateSessionAndLogout } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if session is valid on component mount
    const validateSession = async () => {
      try {
        await validateSessionAndLogout();
      } finally {
        setIsLoading(false);
      }
    };
    
    validateSession();
  }, [validateSessionAndLogout]);

  if (isLoading) {
    return <div className="loading">Verifying session...</div>;
  }

  return (
    <div className='home-container'>
      {/* Header Section */}
      <header className='home-header'>
        <h1>Welcome to RealTime</h1>
        <p>Your ultimate platform for empowering realtors and brokerages.</p>
      </header>

      {/* Features Section */}
      <section className='features'>
        <h2>Our Tools</h2>
        <div className='feature-cards'>
          <div className='feature-card'>
              <div className='feature-header'>
                  <img src={smartCMA} alt='Smart CMA' className='feature-icon' />
                  <h3>Smart CMA</h3>
              </div>
              <p>Create accurate, data-driven Comparative Market Analyses with ease.</p>
              <button onClick={() => history.push('/smart-cma')}>Explore Smart CMA</button>
          </div>

          <div className='feature-card'>
              <div className='feature-header'>
                  <img src={smartSearch} alt='Smart Marketing' className='feature-icon' />
                  <h3>Smart Marketing</h3>
              </div>
              <p>Enhance your marketing efforts with powerful and automated tools.</p>
              <button onClick={() => history.push('/smart-marketing')}>Explore Smart Marketing</button>
          </div>

          <div className='feature-card'>
              <div className='feature-header'>
                  <img src={smartReport} alt='Smart Reports' className='feature-icon' />
                  <h3>Smart Reports</h3>
              </div>
              <p>Generate professional reports to impress your clients and close deals faster.</p>
              <button onClick={() => history.push('/smart-reports')}>Explore Smart Reports</button>
          </div>

        </div>
      </section>

      {/* Footer Section */}
      <footer className='footer'>
        <p>© 2025 RealTime. All rights reserved.</p>
        <div className='footer-links'>
          <a href='/about'>About</a> | <a href='/contact'>Contact</a>
        </div>
      </footer>
    </div>
  );
};

export default Home;
